import React from 'react';

const icons = {
  dashboard: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
    </svg>
  ),
  list: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
      <line x1="8" y1="18" x2="21" y2="18"/><circle cx="3" cy="6" r="1.5" fill="currentColor" stroke="none"/>
      <circle cx="3" cy="12" r="1.5" fill="currentColor" stroke="none"/>
      <circle cx="3" cy="18" r="1.5" fill="currentColor" stroke="none"/>
    </svg>
  ),
  scan: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M3 7V5a2 2 0 0 1 2-2h2"/><path d="M17 3h2a2 2 0 0 1 2 2v2"/>
      <path d="M21 17v2a2 2 0 0 1-2 2h-2"/><path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
    </svg>
  ),
  reports: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  ),
  estimate: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
      <circle cx="12" cy="13" r="4"/>
    </svg>
  )
};

const AddIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

export default function NavBar({ current, onNavigate }) {
  return (
    <nav className="nav-bar">
      <button className={`nav-item ${current === 'dashboard' ? 'active' : ''}`} onClick={() => onNavigate('dashboard')}>
        {icons.dashboard}
        Home
      </button>
      <button className={`nav-item ${current === 'list' ? 'active' : ''}`} onClick={() => onNavigate('list')}>
        {icons.list}
        Expenses
      </button>
      <button className={`nav-item ${current === 'scan' ? 'active' : ''}`} onClick={() => onNavigate('scan')}>
        {icons.scan}
        Scan
      </button>
      <button className="nav-add-btn" onClick={() => onNavigate('add')}>
        <div className="add-circle"><AddIcon /></div>
      </button>
      <button className={`nav-item ${current === 'estimate' ? 'active' : ''}`} onClick={() => onNavigate('estimate')}>
        {icons.estimate}
        AI Est.
      </button>
      <button className={`nav-item ${current === 'reports' ? 'active' : ''}`} onClick={() => onNavigate('reports')}>
        {icons.reports}
        Reports
      </button>
    </nav>
  );
}
